// "Dov'è il mio ordine?" (sections/main-order-lookup.liquid). Sends order number + email in a POST body (never in the
// URL) to the app proxy and shows only shipping status, tracking links and expected dates.
(() => {
  const form = document.querySelector('[data-order-lookup]');
  if (!form) return;
  const t = JSON.parse(form.dataset.i18n);
  const out = document.querySelector('[data-order-result]');
  const err = form.querySelector('.order-lookup__error');
  const btn = form.querySelector('button');
  const locale = document.documentElement.lang || 'it';
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const day = (iso, month = true) => new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'short', day: 'numeric', ...(month ? { month: 'short' } : {}) }).format(new Date(iso));
  const range = (a, b) => `${day(a, new Date(a).getUTCMonth() !== new Date(b).getUTCMonth())} - ${day(b)}`;
  const safeUrl = (u) => (/^https:\/\//.test(u || '') ? u : null);

  // Result card (owner 2026-10-22): order number + status badge, then label/value rows; capitalised labels.
  const cap = (x) => String(x || '').charAt(0).toUpperCase() + String(x || '').slice(1);
  const row = (label, value) => `<div class="ol-row"><dt>${esc(label)}</dt><dd>${value}</dd></div>`;
  const render = (s) => {
    const rows = [];
    if (s.expected?.length && !['delivered', 'cancelled'].includes(s.status)) {
      s.expected.forEach((e, i) => rows.push(row(s.expected.length > 1 ? `${t.parcel.replace('{{ number }}', i + 1)} · ${t.expected}` : cap(t.expected), esc(range(e.from, e.to)))));
    }
    const tracks = [];
    s.shipments?.forEach((sh, i) => {
      const tr = sh.tracking?.[0];
      const label = `${cap(sh.deliveredAt ? t.delivered_on : t.shipped_on)}${s.shipments.length > 1 ? ` (${i + 1})` : ''}`;
      rows.push(row(label, `${esc(day(sh.deliveredAt || sh.shippedAt))}${tr?.company ? ` · ${esc(tr.company)}` : ''}`));
      if (tr && safeUrl(tr.url)) tracks.push(`<a class="button" href="${esc(tr.url)}" target="_blank" rel="noopener">${esc(t.track)}${s.shipments.length > 1 ? ` (${i + 1})` : ''}</a>`);
    });
    // Actions (owner 2026-10-22): tracking as a button, the full-order login next to it as an outline button.
    out.innerHTML = `<div class="ol-head"><strong>${esc(t.order)} ${esc(s.order)}</strong><span class="ol-badge ol-badge--${esc(s.status)}">${esc(cap(t[`status_${s.status}`] || s.status))}</span></div>`
      + (rows.length ? `<dl class="ol-rows">${rows.join('')}</dl>` : '')
      + `<div class="ol-actions">${tracks.join('')}<a class="button ol-outline" href="${esc(form.dataset.login || '/account/login')}">${esc(t.full_order)}</a></div>`;
    out.hidden = false;
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    err.hidden = true; out.hidden = true;
    const order = form.order.value.trim(), email = form.email.value.trim();
    if (!order || !email) { err.textContent = t.error_input; err.hidden = false; return; }
    btn.disabled = true;
    try {
      const r = await fetch('/apps/ordine', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ order, email }) });
      const data = await r.json().catch(() => ({}));
      if (r.ok) render(data);
      else { err.textContent = t[`error_${data.error}`] || t.error_not_found; err.hidden = false; }
    } catch { err.textContent = t.error_network; err.hidden = false; }
    btn.disabled = false;
  });
})();
